import {
  addScrollToEndListener,
  removeScrollToEndListener,
  ScrollToEndManager,
  TmDialogElement,
} from '@thiememeulenhoff/lit-sdk';
import { html } from 'lit';
import { customElement, property, query } from 'lit/decorators.js';
import { styles, tag } from './drawer.styles';
import { DrawerPlacement, DrawerSize } from './drawer.types';

@customElement(tag)
export class DrawerComponent extends TmDialogElement {
  static override styles = [styles];

  @property({ type: String })
  placement: DrawerPlacement = 'right';

  @property({ type: String })
  size: DrawerSize = 'default';

  @query('main')
  main!: HTMLElement;

  scrollToEndManager?: ScrollToEndManager;

  override async connectedCallback(): Promise<void> {
    await super.connectedCallback();

    this.scrollToEndManager = addScrollToEndListener(this.main, this);
  }

  override disconnectedCallback() {
    super.disconnectedCallback();

    if (this.scrollToEndManager) {
      removeScrollToEndListener(this.scrollToEndManager);
    }
  }

  protected override closeButton() {
    return html`<a-icon-button
      icon="close"
      class="close"
      color="grey"
      icon-size="medium"
      @click=${this.close}
      aria-label="Sluiten"
      role="button"
    ></a-icon-button>`;
  }

  override dialogContent() {
    return html`
      <content>
        <header sticky part="header">
          <span class="title"><slot name="title">Side panel title</slot></span>
          ${this.closeButton()}
        </header>
        <main id="content" part="main"><slot></slot></main>
        <footer sticky part="footer"><slot name="footer"></slot></footer>
      </content>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'a-drawer': DrawerComponent;
  }
}
